export default __webpack_public_path__ + "static/media/a5.31abe852.jpg";